import { useId } from 'react';

// Hole positions on a 100×100 ball, as [cx, cy, r]. Smaller and flatter
// towards the rim so the ball reads as a sphere rather than a flat disc.
const HOLES = [
  [50, 50, 7], [30, 36, 6], [70, 36, 6], [32, 66, 6], [68, 66, 6],
  [50, 22, 5], [50, 79, 5], [17, 52, 4], [83, 52, 4],
  [25, 18, 3], [75, 18, 3], [22, 84, 3], [78, 84, 3],
];

/**
 * A shaded pickleball, drawn in SVG so it rasterises cleanly at any size and
 * needs no image file.
 * @param {object} props
 * @param {number} props.size - px
 * @param {string} [props.className]
 * @param {object} [props.style]
 * @returns {JSX.Element}
 */
function PickleballBall({ size, className = '', style }) {
  // Gradient ids must be unique per instance — all four templates sit in the
  // same document while they render. useId's punctuation is stripped because
  // it isn't safe inside url(#...).
  const uid = useId().replace(/[^a-zA-Z0-9_-]/g, '');
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" className={className} style={style} aria-hidden="true">
      <defs>
        <radialGradient id={`${uid}-body`} cx="35%" cy="30%" r="75%">
          <stop offset="0%" stopColor="#f2ff8a" />
          <stop offset="45%" stopColor="#c8ec3a" />
          <stop offset="100%" stopColor="#6f9d16" />
        </radialGradient>
        <radialGradient id={`${uid}-hole`} cx="40%" cy="35%" r="70%">
          <stop offset="0%" stopColor="#5c8a12" />
          <stop offset="100%" stopColor="#3f6609" />
        </radialGradient>
      </defs>
      <circle cx="50" cy="50" r="48" fill={`url(#${uid}-body)`} />
      {HOLES.map(([cx, cy, r]) => (
        <circle key={`${cx}-${cy}`} cx={cx} cy={cy} r={r} fill={`url(#${uid}-hole)`} opacity="0.9" />
      ))}
      <ellipse cx="34" cy="26" rx="14" ry="8" fill="#ffffff" opacity="0.35" />
    </svg>
  );
}

export default PickleballBall;
